var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystalRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 188,
    viewBox: "0 0 270 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3654_4076)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8506 101.943C37.9589 102.61 60.7318 109.349 62.213 116.755C63.1075 122.908 64.8652 128.904 67.4341 134.566C56.3254 126.864 54.7331 119.384 45.5129 114.866C37.5516 111.163 29.6644 107.461 24.8506 101.869V101.943Z",
    fill: "url(#paint0_radial_3654_4076)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.658 120.161C53.5482 112.459 33.4414 106.349 24.8506 101.942C37.9589 102.609 60.7318 109.348 62.213 116.754C63.1075 122.907 64.8652 128.903 67.4341 134.565C65.1585 129.576 62.5609 124.739 59.658 120.087V120.161Z",
    fill: "url(#paint1_radial_3654_4076)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.693 119.493C61.8784 115.123 40.7347 105.94 36.032 103.977C26.4044 99.9041 16.7398 95.7198 10.7411 84.6851C9.50585 82.3046 8.46559 79.8279 7.63062 77.2793C11.889 79.2418 16.1844 80.9822 20.4057 83.241C29.4779 87.7215 39.2165 92.5723 47.9924 97.5713C55.6575 101.941 60.5083 105.31 61.397 111.383C61.6562 113.346 62.3598 117.715 62.693 119.567V119.493Z",
    fill: "url(#paint2_radial_3654_4076)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5466 106.903C38.1427 97.1639 20.2946 94.4978 7.63062 77.2793C11.889 79.2418 16.1844 80.9822 20.4057 83.241C29.4779 87.7215 39.2165 92.5723 47.9924 97.5713C55.6575 101.941 60.5083 105.31 61.397 111.383C61.6562 113.346 62.3598 117.715 62.693 119.567C62.7036 119.419 62.7036 119.27 62.693 119.122C60.8786 113.457 59.8047 110.013 54.6947 106.977L54.5466 106.903Z",
    fill: "url(#paint3_radial_3654_4076)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4697 111.828C60.6921 106.533 55.0266 102.2 47.954 98.1639C39.8816 93.6093 30.8836 89.6472 22.9964 85.0186C8.1847 76.3167 4.48178 70.2069 4.29663 51.6924C10.0138 57.7083 16.4425 63.0055 23.4407 67.4668C33.3645 74.132 59.2479 87.0552 60.4699 100.089C60.7291 104.052 61.0994 107.94 61.5807 111.717L61.4697 111.828Z",
    fill: "url(#paint4_radial_3654_4076)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5444 98.1642C49.694 90.1659 32.6606 82.3527 23.2181 76.7243C12.3316 70.0961 7.11045 64.2085 4 51.8037C9.7172 57.8196 16.1459 63.1168 23.1441 67.5781C33.0679 74.2434 58.9513 87.1665 60.1732 100.201C60.4324 104.163 60.8027 108.051 61.2841 111.828C61.2401 111.553 61.1782 111.281 61.099 111.013C60.5388 106.449 58.9841 102.063 56.5444 98.1642Z",
    fill: "url(#paint5_radial_3654_4076)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5099 102.646C59.6212 93.167 47.5497 84.9835 28.8499 73.5045C13.1126 63.8399 3.96635 53.1755 6.63245 32.7725C16.6712 44.2663 28.4095 54.1564 41.4398 62.0995C54.2149 70.5792 59.0287 78.9478 59.9544 90.9082C59.9544 91.945 59.9544 92.9448 59.9544 93.9446C59.9544 96.8329 60.2507 99.7211 60.4358 102.572L60.5099 102.646Z",
    fill: "url(#paint6_radial_3654_4076)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1041 74.168C28.0337 61.5041 10.667 56.7643 6.70483 32.7324C16.7436 44.2262 28.4819 54.1164 41.5123 62.0595C54.2873 70.5392 59.1011 78.9077 60.0269 90.8681C60.0269 91.905 60.0269 92.9048 60.0269 93.9045C60.0269 96.7928 60.3231 99.6811 60.5083 102.532C60.5286 102.323 60.5286 102.112 60.5083 101.903C60.1558 96.4274 58.591 91.0987 55.9269 86.3022C53.2628 81.5056 49.5661 77.3609 45.1041 74.168Z",
    fill: "url(#paint7_radial_3654_4076)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9878 93.4994C58.5437 76.2068 47.1017 67.0976 34.4377 58.3958C28.7922 54.7721 23.5533 50.5511 18.8114 45.8059C11.998 38.6222 8.8876 30.2166 11.4056 15.7012C19.5977 24.006 28.7317 31.3256 38.622 37.5113C56.7663 49.5458 59.3584 55.4334 59.5065 74.5405C59.5065 80.7613 59.5065 87.2414 59.9138 93.6475L59.9878 93.4994Z",
    fill: "url(#paint8_radial_3654_4076)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2863 85.2786C56.5092 67.0602 53.3987 60.9875 39.883 51.3599C23.6272 39.7698 13.5924 35.0301 11.4817 15.5527C19.6738 23.8576 28.8078 31.1772 38.6981 37.3629C56.8424 49.3974 59.4345 55.285 59.5826 74.392C59.5826 80.6129 59.5825 87.093 59.9899 93.499C59.7677 90.7589 59.6937 88.0558 59.2863 85.4267V85.2786Z",
    fill: "url(#paint9_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1111 19.7725C12.4499 26.5755 15.362 32.9955 20.2575 37.7316C25.7008 43.1749 37.5131 49.9512 44.4005 54.9131C36.9947 48.1738 27.4782 43.1749 21.3684 36.7688C16.7978 32.0481 13.5978 26.1728 12.1111 19.7725Z",
    fill: "url(#paint10_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88892 41.3242C11.2958 57.3949 35.4758 67.2446 46.6586 75.5021C36.8459 65.9486 14.5173 57.9503 8.88892 41.3242Z",
    fill: "url(#paint11_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59277 58.8418C10.5549 72.8388 27.9586 80.2446 37.8084 84.7622C30.4026 80.1335 13.184 73.061 6.59277 58.8418Z",
    fill: "url(#paint12_radial_3654_4076)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.505 101.943C231.397 102.61 208.587 109.349 207.143 116.755C206.248 122.908 204.49 128.904 201.922 134.566C213.03 126.864 214.623 119.384 223.806 114.866C231.804 111.163 239.691 107.461 244.505 101.869V101.943Z",
    fill: "url(#paint13_radial_3654_4076)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.661 120.161C215.77 112.459 235.914 106.349 244.505 101.942C231.397 102.609 208.587 109.348 207.143 116.754C206.248 122.907 204.49 128.903 201.922 134.565C204.185 129.576 206.77 124.74 209.661 120.087V120.161Z",
    fill: "url(#paint14_radial_3654_4076)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.662 119.493C207.44 115.123 228.62 105.94 233.323 103.977C242.951 99.9041 252.578 95.7198 258.577 84.6851C259.809 82.2984 260.861 79.8229 261.725 77.2793C257.466 79.2418 253.134 80.9822 248.913 83.241C239.877 87.7215 230.102 92.5723 221.326 97.5713C213.661 101.941 208.847 105.31 207.958 111.383C207.699 113.346 206.958 117.715 206.662 119.567V119.493Z",
    fill: "url(#paint15_radial_3654_4076)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.77 106.903C231.174 97.1639 249.022 94.4978 261.723 77.2793C257.465 79.2418 253.133 80.9822 248.911 83.241C239.876 87.7215 230.1 92.5723 221.324 97.5713C213.659 101.941 208.846 105.31 207.957 111.383C207.698 113.346 206.957 117.715 206.661 119.567C206.648 119.419 206.648 119.27 206.661 119.122C208.512 113.457 209.549 110.013 214.659 106.977L214.77 106.903Z",
    fill: "url(#paint16_radial_3654_4076)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.884 111.828C208.662 106.533 214.29 102.2 221.363 98.1639C229.435 93.6093 238.433 89.6472 246.358 85.0186C261.169 76.3167 264.872 70.2069 264.872 51.6924C259.155 57.7083 252.726 63.0055 245.728 67.4668C235.804 74.132 209.921 87.0552 208.699 100.089C208.44 104.052 208.07 107.94 207.588 111.717L207.884 111.828Z",
    fill: "url(#paint17_radial_3654_4076)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.66 98.1642C219.51 90.1659 236.544 82.3527 245.801 76.7243C256.688 70.0961 261.909 64.2085 265.019 51.8037C259.302 57.8196 252.873 63.1168 245.875 67.5781C235.951 74.2434 210.068 87.1665 208.846 100.201C208.587 104.163 208.216 108.051 207.735 111.828C207.718 111.557 207.718 111.285 207.735 111.013C208.335 106.447 209.914 102.064 212.364 98.1642H212.66Z",
    fill: "url(#paint18_radial_3654_4076)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.81 102.646C209.736 93.167 221.771 84.9835 240.47 73.5045C256.245 63.8399 265.391 53.1755 262.688 32.7725C252.641 44.2576 240.904 54.1465 227.88 62.0995C215.068 70.5792 210.291 78.9478 209.366 90.9082V93.9446C209.366 96.8329 209.07 99.7211 208.847 102.572L208.81 102.646Z",
    fill: "url(#paint19_radial_3654_4076)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.252 74.168C241.286 61.5041 258.652 56.7643 262.652 32.7324C252.604 44.2176 240.867 54.1065 227.844 62.0595C215.032 70.5392 210.255 78.9077 209.33 90.8681V93.9045C209.33 96.7928 209.033 99.6811 208.811 102.532C208.791 102.323 208.791 102.112 208.811 101.903C209.186 96.4286 210.764 91.1044 213.433 86.3103C216.102 81.5161 219.796 77.3701 224.252 74.168Z",
    fill: "url(#paint20_radial_3654_4076)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.328 93.4994C210.809 76.2068 222.252 67.0976 234.915 58.3958C240.547 54.7532 245.784 50.5337 250.542 45.8059C257.318 38.6222 260.429 30.2166 257.948 15.7012C249.717 24.0241 240.532 31.345 230.583 37.5113C212.476 49.5458 209.847 55.4334 209.699 74.5405C209.699 80.7613 209.699 87.2414 209.291 93.6475L209.328 93.4994Z",
    fill: "url(#paint21_radial_3654_4076)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.032 85.2786C212.809 67.0602 215.92 60.9875 229.472 51.3599C245.728 39.7698 255.726 35.0301 257.836 15.5527C249.649 23.9207 240.501 31.2913 230.583 37.511C212.476 49.5455 209.847 55.4331 209.699 74.5401C209.699 80.761 209.699 87.2411 209.291 93.6472C209.55 90.907 209.588 88.2039 209.995 85.5748L210.032 85.2786Z",
    fill: "url(#paint22_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.246 19.7725C256.907 26.5755 253.995 32.9955 249.099 37.7316C243.656 43.1749 231.881 49.9512 224.956 54.9131C232.362 48.1738 241.879 43.1749 248.025 36.7688C252.572 32.0361 255.757 26.1643 257.246 19.7725Z",
    fill: "url(#paint23_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.43 41.3242C258.06 57.3949 233.843 67.2446 222.66 75.5021C232.473 65.9486 254.801 57.9503 260.43 41.3242Z",
    fill: "url(#paint24_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.724 58.8418C258.762 72.8388 241.358 80.2446 231.509 84.7622C238.914 80.1335 256.17 73.061 262.724 58.8418Z",
    fill: "url(#paint25_radial_3654_4076)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9162 48.6557L134.679 7.2201V0.18457L56.8064 45.1379L62.9162 48.6557Z",
    fill: "url(#paint26_radial_3654_4076)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.676 7.2201L206.439 48.6557L212.548 45.1379L134.676 0.18457V7.2201Z",
    fill: "url(#paint27_radial_3654_4076)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.79 17.774L134.677 11.5161V7.2207L62.9141 48.6563L66.617 50.804L94.648 34.6223L123.79 17.774Z",
    fill: "url(#paint28_radial_3654_4076)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.676 11.5161L168.706 31.1415L202.736 50.804L206.439 48.6563L134.676 7.2207V11.5161Z",
    fill: "url(#paint29_radial_3654_4076)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9162 131.531V48.6594L56.8064 45.1416V135.048L62.9162 131.531Z",
    fill: "url(#paint30_radial_3654_4076)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9141 48.6592V131.53L66.617 129.383V90.0948V50.8069L62.9141 48.6592Z",
    fill: "url(#paint31_radial_3654_4076)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.739 74.9128V90.0948V129.383L206.442 131.53V48.6592L202.739 50.8069V74.9128Z",
    fill: "url(#paint32_radial_3654_4076)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.442 48.6594V131.531L212.552 135.048V45.1416L206.442 48.6594Z",
    fill: "url(#paint33_radial_3654_4076)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.647 149.044L87.5014 141.453L66.617 129.382L62.9141 131.53L134.677 172.965V168.67L100.647 149.044Z",
    fill: "url(#paint34_radial_3654_4076)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.679 172.965L62.9162 131.529L56.8064 135.047L134.679 180V172.965Z",
    fill: "url(#paint35_radial_3654_4076)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.931 157.561L134.676 168.67V172.965L206.439 131.53L202.736 129.382L183.073 140.713L168.706 149.044L153.931 157.561Z",
    fill: "url(#paint36_radial_3654_4076)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.439 131.529L134.676 172.965V180L212.548 135.047L206.439 131.529Z",
    fill: "url(#paint37_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.679 0.11109V7.14662L62.9162 48.6563L56.8064 44.9534C64.8417 44.9534 72.1364 41.8059 89.5772 31.4748L106.611 21.625C124.274 11.7012 130.717 6.9985 134.679 0V0.11109Z",
    fill: "url(#paint38_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.736 129.382L206.439 131.53L134.676 172.965V168.818C138.157 170.299 143.785 166.078 161.337 155.969L178.37 146.119C195.922 135.973 201.884 133.122 202.736 129.382Z",
    fill: "url(#paint39_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.277 26.4759L133.863 6.70233L134.678 0.925781L135.492 6.70233L145.416 13.4046L134.678 8.22052L101.277 26.4759Z",
    fill: "url(#paint40_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.043 156.006L206.478 132.492L211.884 134.677L207.293 131.085L206.441 109.646L205.552 131.011L164.043 156.006Z",
    fill: "url(#paint41_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2782 29.3662L62.878 47.6956L57.4717 45.5109L62.0633 49.1027L62.915 96.426L63.7666 49.1398L96.2782 29.3662Z",
    fill: "url(#paint42_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2782 150.821L62.878 132.492L57.4717 134.677L62.0633 131.085L62.915 105.757L63.7666 131.011L96.2782 150.821Z",
    fill: "url(#paint43_radial_3654_4076)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.914 90.0909L56.8042 73.4648L40.6965 90.0909L56.8042 106.717L62.914 90.0909Z",
    fill: "#F56D00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.914 90.0909L56.8042 73.4648L40.6965 90.0909H62.914Z",
    fill: "url(#paint44_radial_3654_4076)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.914 90.0928L56.8042 106.719L40.6965 90.0928H62.914Z",
    fill: "url(#paint45_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5088 87.5752C48.8059 89.0564 44.8438 89.5008 43.4367 87.242L40.6965 90.0932H62.914L60.322 83.0947C59.8776 84.687 55.5082 86.4273 52.5088 87.5752Z",
    fill: "url(#paint46_radial_3654_4076)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7978 27.9212L110.129 14.3316L87.6891 8.70312L81.3201 30.9576L98.7978 27.9212Z",
    fill: "#F56D00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7969 27.9212L110.128 14.3316L87.6881 8.70312L98.7969 27.9212Z",
    fill: "url(#paint47_radial_3654_4076)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7978 27.9212L81.3201 30.9576L87.6891 8.70312L98.7978 27.9212Z",
    fill: "url(#paint48_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7614 17.6642C92.5399 15.0721 90.2811 12.0357 91.5031 9.66588L87.8002 8.70312L93.5767 18.9232L98.7978 27.9212L103.538 22.3298C101.982 22.7372 98.2424 19.8119 95.7614 17.7753V17.6642Z",
    fill: "url(#paint49_radial_3654_4076)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.558 27.9212L187.999 30.9576L181.667 8.70312L159.19 14.3316L170.558 27.9212Z",
    fill: "#F56D00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.559 27.9212L188 30.9576L181.668 8.70312L170.559 27.9212Z",
    fill: "url(#paint50_radial_3654_4076)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.558 27.9212L159.19 14.3316L181.667 8.70312L170.558 27.9212Z",
    fill: "url(#paint51_radial_3654_4076)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.442 90.0909L212.552 73.4648L228.659 90.0909L212.552 106.717L206.442 90.0909Z",
    fill: "#F56D00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.442 90.0909L212.552 73.4648L228.659 90.0909H206.442Z",
    fill: "url(#paint52_radial_3654_4076)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.442 90.0928L212.552 106.719L228.659 90.0928H206.442Z",
    fill: "url(#paint53_radial_3654_4076)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.558 152.227L187.999 149.19L181.667 171.482L159.19 165.817L170.558 152.227Z",
    fill: "#F56D00"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.559 152.227L188 149.19L181.668 171.482L170.559 152.227Z",
    fill: "url(#paint54_radial_3654_4076)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.558 152.229L159.19 165.818L181.667 171.484L170.558 152.229Z",
    fill: "url(#paint55_radial_3654_4076)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7978 152.227L110.129 165.817L87.6891 171.482L81.3201 149.19L98.7978 152.227Z",
    fill: "#F56D00"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7969 152.229L110.128 165.818L87.6881 171.484L98.7969 152.229Z",
    fill: "url(#paint56_radial_3654_4076)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7978 152.227L81.3201 149.19L87.6891 171.482L98.7978 152.227Z",
    fill: "url(#paint57_radial_3654_4076)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6169 129.381L134.677 168.669L202.736 129.381V50.8055L134.677 11.5176L66.6169 50.8055V129.381Z",
    fill: "#0EC89C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9141 90.0901L66.617 98.4957L73.7266 90.0901L66.617 81.6475L62.9141 90.0901Z",
    fill: "#868686"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6169 129.381L134.677 168.669L202.736 129.381V50.8055L134.677 11.5176L66.6169 50.8055V129.381Z",
    fill: "#0EC89C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.087 12.9972L134.679 7.2207L137.234 12.9972V29.4011L134.679 31.2156L132.087 29.4011V12.9972Z",
    fill: "#F56D00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.146 49.2887L206.441 48.6592L202.738 53.7692L188.481 61.9897L185.667 60.6566L185.926 57.5091L200.146 49.2887Z",
    fill: "#F56D00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.738 126.38L206.441 131.527L200.146 130.86L185.926 122.64L185.667 119.529L188.481 118.196L202.738 126.38Z",
    fill: "#F56D00"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.087 167.188L134.679 172.965L137.234 167.188V150.747L134.679 148.97L132.087 150.747V167.188Z",
    fill: "#F56D00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.617 126.38L62.9141 131.527L69.172 130.86L83.4282 122.64L83.6874 119.529L80.8362 118.196L66.617 126.38Z",
    fill: "#F56D00"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.172 49.2887L62.9141 48.6592L66.617 53.7692L80.8362 61.9897L83.6874 60.6566L83.4282 57.5091L69.172 49.2887Z",
    fill: "#F56D00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7265 115.015V65.1365L66.6169 53.7686V126.383L73.7265 115.015Z",
    fill: "url(#paint58_radial_3654_4076)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7262 65.1348V115.013L80.8358 118.198V61.9873L73.7262 65.1348Z",
    fill: "url(#paint59_radial_3654_4076)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6169 53.7686L73.7265 65.1365L80.8361 61.989L66.6169 53.7686Z",
    fill: "url(#paint60_radial_3654_4076)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6169 126.383L73.7265 115.015L80.8361 118.199L66.6169 126.383Z",
    fill: "url(#paint61_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8391 55.7666L72.9491 65.6904L73.7267 86.1305L74.2821 65.8756L78.8738 62.8762L73.9119 64.5055L67.8391 55.7666Z",
    fill: "url(#paint62_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8391 124.418L72.9491 114.494L73.7267 103.2L74.2821 114.309L78.8738 117.308L73.9119 115.679L67.8391 124.418Z",
    fill: "url(#paint63_radial_3654_4076)"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.741 130.38L143.528 155.338L137.233 167.187L200.145 130.861L186.741 130.38Z",
    fill: "url(#paint64_radial_3654_4076)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.528 155.337L186.741 130.38L185.926 122.641L137.233 150.746L143.528 155.337Z",
    fill: "url(#paint65_radial_3654_4076)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.233 167.185L143.528 155.336L137.233 150.744V167.185Z",
    fill: "url(#paint66_radial_3654_4076)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.147 130.861L186.742 130.38L185.927 122.641L200.147 130.861Z",
    fill: "url(#paint67_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.343 165.114L144.379 155.709L161.745 144.822L143.86 154.487L139.009 152.006L142.86 155.487L138.343 165.114Z",
    fill: "url(#paint68_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.811 130.787L186.665 131.305L176.482 136.304L185.813 130.268L186.147 124.788L187.221 129.898L197.811 130.787Z",
    fill: "url(#paint69_radial_3654_4076)"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.791 155.338L82.5781 130.38L69.1736 130.861L132.086 167.187L125.791 155.338Z",
    fill: "url(#paint70_radial_3654_4076)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5785 130.38L125.792 155.337L132.086 150.746L83.4301 122.641L82.5785 130.38Z",
    fill: "url(#paint71_radial_3654_4076)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1736 130.861L82.5781 130.38L83.4298 122.641L69.1736 130.861Z",
    fill: "url(#paint72_radial_3654_4076)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.086 167.185L125.791 155.336L132.086 150.744V167.185Z",
    fill: "url(#paint73_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5059 130.787L82.6887 131.305L100.796 140.896L83.5033 130.268L83.1701 124.788L82.1333 129.898L71.5059 130.787Z",
    fill: "url(#paint74_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.973 165.114L124.938 155.709L115.532 149.414L125.456 154.487L130.344 152.006L126.456 155.487L130.973 165.114Z",
    fill: "url(#paint75_radial_3654_4076)"
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.626 115.015V65.1365L202.736 53.7686V126.383L195.626 115.015Z",
    fill: "url(#paint76_radial_3654_4076)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.627 65.1348V115.013L188.48 118.198V61.9873L195.627 65.1348Z",
    fill: "url(#paint77_radial_3654_4076)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.737 53.7686L195.627 65.1365L188.48 61.989L202.737 53.7686Z",
    fill: "url(#paint78_radial_3654_4076)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.737 126.383L195.627 115.015L188.48 118.199L202.737 126.383Z",
    fill: "url(#paint79_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.478 55.7666L196.368 65.6904L195.627 86.1305L195.035 65.8756L190.48 62.8762L195.405 64.5055L201.478 55.7666Z",
    fill: "url(#paint80_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.478 124.418L196.368 114.494L195.627 103.2L195.035 114.309L190.48 117.308L195.405 115.679L201.478 124.418Z",
    fill: "url(#paint81_radial_3654_4076)"
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.791 24.8493L82.5781 49.7699L69.1736 49.2885L132.086 13L125.791 24.8493Z",
    fill: "url(#paint82_radial_3654_4076)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5785 49.7663L125.792 24.8457L132.086 29.4003L83.4301 57.5054L82.5785 49.7663Z",
    fill: "url(#paint83_radial_3654_4076)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1736 49.2871L82.5781 49.7685L83.4298 57.5076L69.1736 49.2871Z",
    fill: "url(#paint84_radial_3654_4076)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.086 13L125.791 24.8493L132.086 29.4039V13Z",
    fill: "url(#paint85_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5059 49.397L82.6887 48.8416L100.796 39.2881L83.5033 49.9154L83.1701 55.3587L82.1333 50.2857L71.5059 49.397Z",
    fill: "url(#paint86_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.973 15.0723L124.938 24.4406L115.532 30.7726L125.456 25.6996L130.344 28.1435L126.456 24.6998L130.973 15.0723Z",
    fill: "url(#paint87_radial_3654_4076)"
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.741 49.7699L143.528 24.8493L137.233 13L200.145 49.2885L186.741 49.7699Z",
    fill: "url(#paint88_radial_3654_4076)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.528 24.8457L186.741 49.7663L185.926 57.5054L137.233 29.4003L143.528 24.8457Z",
    fill: "url(#paint89_radial_3654_4076)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.233 13L143.528 24.8493L137.233 29.4039V13Z",
    fill: "url(#paint90_radial_3654_4076)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.147 49.2871L186.742 49.7685L185.927 57.5076L200.147 49.2871Z",
    fill: "url(#paint91_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.343 15.0723L144.379 24.4406L161.745 35.3272L143.86 25.6996L139.009 28.1435L142.86 24.6998L138.343 15.0723Z",
    fill: "url(#paint92_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.811 49.3962L186.665 48.8407L176.482 43.8418L185.813 49.9146L186.147 55.3578L187.221 50.2849L197.811 49.3962Z",
    fill: "url(#paint93_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2061 34.2897C96.9464 34.66 98.4276 38.6221 97.724 41.029L113.647 31.8458C112.904 30.6382 112.493 29.2565 112.454 27.8394C112.415 26.4223 112.749 25.02 113.424 23.7734L95.2061 34.2897Z",
    fill: "url(#paint94_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.629 140.822C181.037 141.229 175.853 139.341 175.223 137.119L161.189 145.191C163.559 145.599 166.781 148.672 166.337 150.45L182.629 140.822Z",
    fill: "url(#paint95_radial_3654_4076)"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.678 33.8828L183.335 61.9879V118.198L134.678 146.266L85.9849 118.198V61.9879L134.678 33.8828Z",
    fill: "#0068FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.018 73.541L116.275 70.4676L126.865 64.3578L134.678 56.989V33.8828L110.35 47.9539L85.9849 61.9879L106.018 73.541Z",
    fill: "url(#paint96_radial_3654_4076)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.676 56.989L142.452 64.3578L153.042 70.4676L163.337 73.541L183.332 61.9879L159.004 47.9539L134.676 33.8828V56.989Z",
    fill: "url(#paint97_radial_3654_4076)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.338 73.5404L160.857 83.9826V96.2022L163.338 106.644L183.333 118.198V90.0924V61.9873L163.338 73.5404Z",
    fill: "url(#paint98_radial_3654_4076)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.337 106.643L153.042 109.716L142.452 115.826L134.676 123.158V146.264L159.004 132.23L183.332 118.196L163.337 106.643Z",
    fill: "url(#paint99_radial_3654_4076)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.678 123.158L126.865 115.826L116.275 109.716L106.018 106.643L85.9849 118.196L110.35 132.23L134.678 146.264V123.158Z",
    fill: "url(#paint100_radial_3654_4076)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.018 106.644L108.499 96.2022V83.9826L106.018 73.5404L85.9849 61.9873V90.0924V118.198L106.018 106.644Z",
    fill: "url(#paint101_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.189 87.9818C165.189 82.9458 182.889 65.7643 183.333 79.2429V61.9873L168.077 70.8002L165.189 82.9458V87.9818Z",
    fill: "url(#paint102_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.018 49.2884C112.165 49.2884 115.646 61.7302 114.979 66.2107L125.57 60.1009C122.941 57.4348 121.311 41.5863 128.865 37.2539L108.018 49.2884Z",
    fill: "url(#paint103_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.298 122.307C169.855 121.863 165.819 121.197 159.969 111.865L156.266 113.05L148.341 117.605C152.452 120.456 160.302 128.713 157.932 133.009L176.447 122.307H176.298Z",
    fill: "url(#paint104_radial_3654_4076)"
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.748 60.0996L156.116 67.2092L165.188 82.9466V97.2028L156.116 112.977L143.748 120.087H125.567L113.236 112.977L104.127 97.2028V82.9466L113.236 67.2092L125.567 60.0996H143.748Z",
    fill: "url(#paint105_radial_3654_4076)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.567 60.0986L134.676 51.5078L143.748 60.0986H125.567Z",
    fill: "url(#paint106_radial_3654_4076)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.116 67.21L168.076 70.8018L165.188 82.9473L156.116 67.21Z",
    fill: "url(#paint107_radial_3654_4076)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.188 97.2012L168.076 109.384L156.116 112.976L165.188 97.2012Z",
    fill: "url(#paint108_radial_3654_4076)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.567 120.088L134.676 128.679L143.748 120.088H125.567Z",
    fill: "url(#paint109_radial_3654_4076)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.13 97.2012L101.241 109.384L113.239 112.976L104.13 97.2012Z",
    fill: "url(#paint110_radial_3654_4076)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.239 67.21L101.241 70.8018L104.13 82.9473L113.239 67.21Z",
    fill: "url(#paint111_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.682 105.09L134.676 90.0935L108.682 75.0967L104.127 82.9469V97.2031L108.682 105.09Z",
    fill: "url(#paint112_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.683 75.0964L134.678 90.0932V60.0996H125.569L113.238 67.2092L108.683 75.0964Z",
    fill: "url(#paint113_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.676 60.0996V90.0932L160.633 75.0964L156.116 67.2092L143.748 60.0996H134.676Z",
    fill: "url(#paint114_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.633 75.0967L134.676 90.0935L160.633 105.09L165.188 97.2031V82.9469L160.633 75.0967Z",
    fill: "url(#paint115_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.633 105.09L134.676 90.0928V120.086H143.748L156.116 112.977L160.633 105.09Z",
    fill: "url(#paint116_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.678 120.086V90.0928L108.683 105.09L113.238 112.977L125.569 120.086H134.678Z",
    fill: "url(#paint117_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.495 116.535L125.679 120.682C128.439 123.241 130.922 126.083 133.085 129.162C134.176 133.925 134.747 138.792 134.789 143.678C134.821 138.773 135.355 133.884 136.381 129.088C136.585 128.541 136.872 128.029 137.232 127.57L140.454 123.311L136.751 125.533C136.163 125.892 135.474 126.048 134.789 125.978C132.2 125.078 130.01 123.295 128.605 120.942L132.863 120.09L126.568 119.609L119.495 116.535Z",
    fill: "url(#paint118_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.495 63.6538L125.567 59.3584C128.319 56.7918 130.8 53.9504 132.973 50.8787C134.057 45.8143 134.628 40.6535 134.676 35.4746C134.711 40.6608 135.244 45.8317 136.269 50.9158C136.472 51.4744 136.759 51.9989 137.12 52.471L140.342 56.7293L136.639 54.4706C136.058 54.095 135.363 53.9376 134.676 54.0262C133.355 54.4645 132.134 55.1618 131.085 56.0773C130.036 56.9929 129.18 58.1083 128.567 59.3584L132.825 60.2101L126.53 60.6914L119.383 63.7649L119.495 63.6538Z",
    fill: "url(#paint119_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.497 63.6525L112.831 66.9111C109.21 68.0065 105.489 68.7383 101.723 69.0958C97.0541 67.6251 92.5498 65.6769 88.281 63.2822C92.5002 65.7828 96.4683 68.6846 100.13 71.947C101.338 73.9863 102.331 76.1456 103.093 78.3901C103.093 76.7238 102.611 73.5393 103.574 72.2062C105.596 70.3579 108.24 69.3398 110.98 69.355L109.573 73.5023L113.276 68.2812L119.497 63.6525Z",
    fill: "url(#paint120_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.189 90.0928L165.707 97.4986C166.57 101.172 167.811 104.746 169.41 108.163C172.689 111.296 176.317 114.041 180.223 116.346C176.233 114.107 172.011 112.306 167.633 110.977C167.044 110.884 166.444 110.884 165.855 110.977L160.56 111.644L164.263 109.607C164.869 109.293 165.352 108.785 165.633 108.163C166.152 105.468 165.706 102.676 164.374 100.276L161.486 103.534L164.226 97.8319L165.115 90.1298L165.189 90.0928Z",
    fill: "url(#paint121_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.571 115.457C113.238 112.976 89.4657 119.641 100.945 126.825L86.1331 118.197L101.389 109.384L113.387 113.087L117.719 115.568L117.571 115.457Z",
    fill: "url(#paint122_radial_3654_4076)"
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6868 60.6527L134.676 31.2145V27.9189L80.8356 59.0234L83.6868 60.6527Z",
    fill: "url(#paint123_radial_3654_4076)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.678 31.2168L83.6886 60.6549L85.9844 61.988L134.678 33.8829V31.2168Z",
    fill: "url(#paint124_radial_3654_4076)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.676 31.2145L185.665 60.6527L188.479 59.0234L134.676 27.9189V31.2145Z",
    fill: "url(#paint125_radial_3654_4076)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.665 60.6549L134.676 31.2168V33.8829L183.332 61.988L185.665 60.6549Z",
    fill: "url(#paint126_radial_3654_4076)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9844 118.198V61.9873L83.6886 60.6543V119.531L85.9844 118.198Z",
    fill: "url(#paint127_radial_3654_4076)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6868 119.533V60.6566L80.8356 59.0273V121.162L83.6868 119.533Z",
    fill: "url(#paint128_radial_3654_4076)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.335 61.9873V118.198L185.668 119.531V60.6543L183.335 61.9873Z",
    fill: "url(#paint129_radial_3654_4076)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.667 60.6566V119.533L188.481 121.162V59.0273L185.667 60.6566Z",
    fill: "url(#paint130_radial_3654_4076)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.678 146.264L85.9844 118.196L83.6886 119.529L134.678 148.967V146.264Z",
    fill: "url(#paint131_radial_3654_4076)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.676 148.97L83.6868 119.532L80.8356 121.162L134.676 152.229V148.97Z",
    fill: "url(#paint132_radial_3654_4076)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.332 118.196L134.676 146.264V148.967L185.665 119.529L183.332 118.196Z",
    fill: "url(#paint133_radial_3654_4076)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.665 119.532L134.676 148.97V152.229L188.479 121.162L185.665 119.532Z",
    fill: "url(#paint134_radial_3654_4076)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.087 12.9972L134.679 7.2207V31.2156L132.087 29.4011V12.9972Z",
    fill: "url(#paint135_radial_3654_4076)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.231 12.9972L134.676 7.2207V31.2156L137.231 29.4011V12.9972Z",
    fill: "url(#paint136_radial_3654_4076)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.146 49.2887L206.441 48.6592L185.667 60.6566L185.926 57.5091L200.146 49.2887Z",
    fill: "url(#paint137_radial_3654_4076)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.738 53.7692L206.441 48.6592L185.667 60.6566L188.481 61.9897L202.738 53.7692Z",
    fill: "url(#paint138_radial_3654_4076)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.738 126.38L206.441 131.527L185.667 119.529L188.481 118.196L202.738 126.38Z",
    fill: "url(#paint139_radial_3654_4076)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.146 130.863L206.441 131.53L185.667 119.532L185.926 122.643L200.146 130.863Z",
    fill: "url(#paint140_radial_3654_4076)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.087 167.188L134.679 172.965V148.97L132.087 150.747V167.188Z",
    fill: "url(#paint141_radial_3654_4076)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.231 167.188L134.676 172.965V148.97L137.231 150.747V167.188Z",
    fill: "url(#paint142_radial_3654_4076)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.617 126.38L62.9141 131.527L83.6874 119.529L80.8362 118.196L66.617 126.38Z",
    fill: "url(#paint143_radial_3654_4076)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.172 130.863L62.9141 131.53L83.6874 119.532L83.4282 122.643L69.172 130.863Z",
    fill: "url(#paint144_radial_3654_4076)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.172 49.2887L62.9141 48.6592L83.6874 60.6566L83.4282 57.5091L69.172 49.2887Z",
    fill: "url(#paint145_radial_3654_4076)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.617 53.7692L62.9141 48.6592L83.6874 60.6566L80.8362 61.9897L66.617 53.7692Z",
    fill: "url(#paint146_radial_3654_4076)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.017 50.6195L133.603 30.4757L134.677 13.4053L135.676 30.5127L150.858 40.5476L134.677 32.179L101.017 50.6195Z",
    fill: "url(#paint147_radial_3654_4076)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.667 80.6875L186.852 118.976L201.071 128.418L185.741 120.753L169.485 128.862L184.815 119.05L185.667 80.6875Z",
    fill: "url(#paint148_radial_3654_4076)"
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9141 90.0928L66.617 98.4984L73.7266 90.0928H62.9141Z",
    fill: "url(#paint149_radial_3654_4076)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9141 90.0901L66.617 81.6475L73.7266 90.0901H62.9141Z",
    fill: "url(#paint150_radial_3654_4076)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.439 90.0901L202.736 98.4957L195.626 90.0901L202.736 81.6475L206.439 90.0901Z",
    fill: "#868686"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.439 90.0928L202.736 98.4984L195.626 90.0928H206.439Z",
    fill: "url(#paint151_radial_3654_4076)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.439 90.0901L202.736 81.6475L195.626 90.0901H206.439Z",
    fill: "url(#paint152_radial_3654_4076)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7978 27.9217L93.3545 35.3645L104.204 37.3271L107.944 26.9219L98.7978 27.9217Z",
    fill: "#868686"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7978 27.9189L93.3545 35.3618L104.204 37.3243L98.7978 27.9189Z",
    fill: "url(#paint153_radial_3654_4076)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7969 27.9217L107.943 26.9219L104.203 37.3271L98.7969 27.9217Z",
    fill: "url(#paint154_radial_3654_4076)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.56 152.227L161.414 153.227L165.153 142.858L176.003 144.821L170.56 152.227Z",
    fill: "#868686"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.56 152.227L161.414 153.227L165.153 142.858L170.56 152.227Z",
    fill: "url(#paint155_radial_3654_4076)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.559 152.227L176.002 144.821L165.153 142.858L170.559 152.227Z",
    fill: "url(#paint156_radial_3654_4076)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.56 27.9217L161.414 26.9219L165.153 37.3271L176.003 35.3645L170.56 27.9217Z",
    fill: "#868686"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.56 27.9217L161.414 26.9219L165.153 37.3271L170.56 27.9217Z",
    fill: "url(#paint157_radial_3654_4076)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.559 27.9189L176.002 35.3618L165.153 37.3243L170.559 27.9189Z",
    fill: "url(#paint158_radial_3654_4076)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7978 152.227L93.3545 144.821L104.204 142.858L107.944 153.227L98.7978 152.227Z",
    fill: "#868686"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7978 152.227L93.3545 144.821L104.204 142.858L98.7978 152.227Z",
    fill: "url(#paint159_radial_3654_4076)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7969 152.227L107.943 153.227L104.203 142.858L98.7969 152.227Z",
    fill: "url(#paint160_radial_3654_4076)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3654_4076",
    x: 0,
    y: 0,
    width: 269.019,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3654_4076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3654_4076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3256 64.5808) scale(63.3569 63.3568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5122 81.2431) scale(51.2484 51.2483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9201 55.5062) scale(60.6538 60.6537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.4034 70.1327) scale(60.5427 60.5426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D95E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0298 20.2547) scale(88.1664 88.1663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4395 34.2149) scale(70.3924 70.3924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.4773 20.8121) scale(72.0588 72.0587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0717 32.7324) scale(66.5044 66.5043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8095 18.2192) scale(72.6512 72.6511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9592 31.8085) scale(53.6182 53.6182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.034 32.9178) scale(33.9187 33.9187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1456 50.0631) scale(33.5484 33.5484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7373 61.9152) scale(32.5487 32.5486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.03 64.5808) rotate(180) scale(63.3569 63.3568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.843 81.2431) rotate(180) scale(51.2484 51.2483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.435 55.5062) rotate(180) scale(60.6537 60.6537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.951 70.1327) rotate(180) scale(60.5427 60.5426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D95E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.324 20.2547) rotate(180) scale(88.1664 88.1663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.913 34.2149) rotate(180) scale(70.3924 70.3924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.843 20.8121) rotate(180) scale(72.0588 72.0587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(246.285 32.7324) rotate(180) scale(66.5044 66.5043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.544 18.2192) rotate(180) scale(72.6513 72.6511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.396 31.8085) rotate(180) scale(53.6182 53.6182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(243.323 32.9178) rotate(180) scale(33.9187 33.9187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.21 50.0631) rotate(180) scale(33.5485 33.5484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245.617 61.9152) rotate(180) scale(32.5486 32.5486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.086 -2.00015) scale(95.5723 95.5722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.815 -31.068) scale(115.05 115.049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.529 45.768) scale(78.8351 78.835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.188 -15.6633) scale(173.259 173.259)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-30.6191 77.0607) scale(137.081 137.082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.869 88.6136) scale(116.605 116.605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.934 92.6868) scale(122.974 122.974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.676 75.4314) scale(128.157 128.158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.75 105.276) scale(105.792 105.792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.678 103.387) scale(130.046 130.046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.588 158.598) scale(92.1656 92.1655)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.12 94.9445) scale(106.385 106.385)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.949 -3.88806) scale(72.355 72.3549)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.153 128.345) scale(60.7649 60.7648)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.568 1.55528) scale(53.359 53.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210.033 133.566) scale(87.2038 87.2036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.8786 36.8461) scale(57.5803 57.5803)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4321 128.789) scale(52.5073 52.5073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0653 94.6825) scale(50.767 50.7669)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.6987 55.8778) scale(56.9508 56.9508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1383 98.1656) scale(31.0675 31.0674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.203 6.74058) scale(54.9513 54.9512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.833 -3.73866) scale(70.8368 70.8367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.7623 4.70398) scale(37.7697 37.7697)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.339 10.2954) scale(49.3968 49.3969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.521 -12.0702) scale(53.3961 53.396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.807 105.902) scale(75.5765 75.5764)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.041 53.8412) scale(65.3194 65.3194)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.748 176.999) scale(51.4334 51.4335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.443 149.97) scale(45.5089 45.5088)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.6551 131.603) scale(57.0989 57.0989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.462 186.183) scale(63.6902 63.6901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.4671 63.3221) scale(72.6141 72.6141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.4289 61.5059) scale(79.0202 79.0202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.7265 67.1731) scale(37.5846 37.5846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5457 84.6878) scale(43.176 43.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5414 63.1354) scale(31.8821 31.8821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.2832 112.902) scale(29.8084 29.8084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.637 79.4278) scale(91.7213 91.7212)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.965 121.974) scale(89.6847 89.6845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.822 145.819) scale(41.9914 41.9911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.779 129.713) scale(28.6976 28.6976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.415 159.264) scale(32.1784 32.1783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.037 128.75) scale(34.1778 34.1779)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.087 153.56) scale(74.7989 74.7989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.755 155.078) scale(53.4701 53.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.0588 130.602) scale(39.6581 39.6582)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.72 143.56) scale(36.4366 36.4367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.355 130.12) scale(30.6231 30.6231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.864 148.414) scale(25.8835 25.8833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179 57.4344) scale(69.208 69.2074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.849 65.8383) scale(70.7254 70.7256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.664 67.8396) scale(17.8481 17.848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.589 96.9074) scale(36.2886 36.2885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.924 60.5804) scale(27.0683 27.0683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.406 111.087) scale(26.0315 26.0315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.161 31.4035) scale(112.68 112.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.421 31.6591) scale(100.46 100.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.43 49.102) scale(72.3178 72.3179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.937 2.85402) scale(47.5454 47.5454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.096 50.2117) scale(35.1407 35.1406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.641 24.7739) scale(26.513 26.5129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.897 22.2203) scale(100.867 100.867)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.602 24.5124) scale(56.0252 56.0251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.12 20.5169) scale(59.4693 59.4688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.631 27.8102) scale(31.3266 31.3267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.934 25.0331) scale(40.8062 40.8061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.665 46.0265) scale(28.068 28.068)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.498 36.0301) scale(56.3213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.743 125.381) scale(29.7714 29.7714)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.383 57.4704) scale(77.5391 77.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.447 73.0967) scale(71.8365 71.8365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.044 66.2827) scale(59.2466 59.2466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.634 76.4638) scale(106.57 106.57)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.936 129.86) scale(72.9105 72.9104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.015 62.5427) scale(64.8751 64.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.961 98.0907) scale(37.5475 37.5475)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D4E0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B2C8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#87A9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.162 63.0632) scale(77.8724 77.8722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.118 107.644) scale(32.6227 32.6227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.197 61.5067) scale(77.9463 77.9463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.678 38.5476) scale(47.4714 47.4713)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.927 49.473) scale(38.4732 38.4733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.225 108.717) scale(47.101 47.101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.342 112.127) scale(45.5459 45.5458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.722 111.902) scale(52.4702 52.4702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.683 67.8395) scale(69.9108 69.911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4008 106.201) scale(100.201 100.201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.756 5.03731) scale(93.9801 93.9799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.003 40.1779) scale(59.4318 59.4317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.222 53.3606) scale(67.0968 67.0968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.891 145.34) scale(100.238 100.238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.682 136.268) scale(65.5417 65.5416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.493 123.089) scale(37.1403 37.1402)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.344 50.6566) scale(33.5114 33.5114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.685 65.2077) scale(31.8451 31.845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.559 109.126) scale(40.8061 40.8061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.793 150.042) scale(48.7674)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D4E0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B2C8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#87A9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.084 44.2858) scale(65.2084 65.2083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.453 90.7967) scale(93.3135 93.3134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.819 14.3663) scale(80.9828 80.9827)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.555 22.2928) scale(74.0953 74.0953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1058 84.1308) scale(105.903 105.903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.2077 73.4317) scale(85.6119 85.6113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.374 82.4274) scale(81.3167 81.316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.266 83.1333) scale(75.4664 75.4654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.306 86.9807) scale(89.3144 89.3143)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.342 92.538) scale(91.425 91.4249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.002 132.378) scale(77.7612 77.7612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.341 103.906) scale(78.1315 78.1315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.234 31.4378) scale(25.3654 25.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.827 19.8847) scale(30.2523 30.2528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.034 35.5879) scale(47.3234 47.3232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.408 66.6553) scale(32.3636 32.3634)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.852 119.085) scale(39.9175 39.9174)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.37 119.903) scale(26.6981 26.698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.568 150.081) scale(24.3286 24.3281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.972 150.266) scale(23.2539 23.2543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.4655 118.381) scale(25.0687 25.0687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.2056 119.421) scale(32.6968 32.6967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.5387 58.3978) scale(48.7674 48.7673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.6121 54.1395) scale(39.5471 39.5471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.381 28.4391) scale(61.8758 61.8757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.629 119.901) scale(59.3207 59.3207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.1703 70.5044) scale(30.3269 30.3269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.8379 91.7564) scale(31.5488 31.5488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.92 63.9132) scale(36.1406 36.1404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.772 91.7564) scale(43.4724 43.4722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.275 16.7362) scale(31.2155 31.2155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.4664 47.3249) scale(31.771 31.771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(174.596 138.082) scale(50.2486 50.2485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(171.929 152.782) scale(35.3631 35.3628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.409 45.0291) scale(31.697 31.6969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.933 8.58975) scale(35.141 35.1406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.6875 136.452) scale(37.0291 37.0292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_3654_4076",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.7618 126.973) scale(39.7323 39.7322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalRank);
export default __webpack_public_path__ + "static/media/crystalRank.e89bd2d6370f83b4de61e39ff90f77d5.svg";
export { ForwardRef as ReactComponent };